import { ScopeTag } from "../shared/common/EstimateEngine/EstimateEngineTypes";

export interface MitToReconSourceScope {
  scope: ScopeTag;
  label: string;
  tagClassName: string;
}

export const MIT_TO_RECON_SOURCE_SCOPES: MitToReconSourceScope[] = [
  { scope: ScopeTag.water_mitigation, label: "Water Mitigation", tagClassName: "bg-blue-100 text-blue-800" },
  { scope: ScopeTag.mold, label: "Mold", tagClassName: "bg-green-100 text-green-800" },
];
